<template>
    <b-card no-body>
         
        <b-modal id="assign-to-tow" :title="'Treyler Ata ' + tow.Plate" no-close-on-esc no-close-on-backdrop>
            <operational-inventory-assign-to-row :is-for-truck="isForTruck" v-model="tow"></operational-inventory-assign-to-row>
            <template #modal-footer><v-executer :loading="loading" text="Ata" :action="assignTrailer"></v-executer></template>
        </b-modal>

        <b-modal id="assign-to-garage-and-duty" :title="'Garaja Ata ' + garageAndDuty.Plate" no-close-on-esc no-close-on-backdrop>
            <operational-inventory-assign-to-garage-and-duty v-model="garageAndDuty"></operational-inventory-assign-to-garage-and-duty>
            <template #modal-footer><v-executer :loading="loading" text="Ata" :action="assignGarageAndDuty"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    name="operationall-inventory"
                    :buttons="buttons"
                    pagination="server"
                    button-alignment="text-left"
                    search>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VehicleOperationsApi from '@/api/vehicle-operations'
import OperationalInventoryAssignToRow from './components/OperationalInventoryAssignToRow.vue'
import OperationalInventoryAssignToGarageAndDuty from './components/OperationalInventoryAssignToGarageAndDuty.vue'

export default {
    components:{
        BCard,
        OperationalInventoryAssignToRow,
        OperationalInventoryAssignToGarageAndDuty
    },
    data(){
        return{
            editing:false,
            loading:false,
            plates:[],
            fields:[
                { name:"Araç Ana Tipi",key:"MainVehicleInventoryBaseType", thClass:"w-10",sortable:true,tdClass:'text-nowrap'},
                { name:"Araç Envanter Numarası",key:"MainVehicleInventoryInventoryNo", thClass:"w-10",sortable:true,tdClass:'text-nowrap'},
                { name:"Araç Plakası",key:"MainVehicleInventoryPlate", thClass:"w-10",sortable:true,sortKey:"MainVehicleInventory.Plate.PlateValue"},
                { name:"Treyler/Römork Envanter Numarası",key:"TrailerVehicleInventoryInventoryNo", thClass:"w-10",sortable:true,sortKey:"MainVehicleInventory.InventoryNo"},
                { name:"Treyler/Römork Plakası",key:"TrailerVehicleInventoryPlate", thClass:"w-10",sortable:true,sortKey:"TrailerVehicleInventory.Plate.PlateValue",tdClass:'text-nowrap'},
                { name:"Garaj",key:"GarageName", thClass:"w-10",sortable:true,sortKey:"VehicleInventoryGarage.GarageName",tdClass:'text-nowrap'},
                { name:"Görev Firması",key:"DutyFirm", thClass:"w-20",sortable:true,sortKey:"DutyFirm.Name",tdClass:'text-nowrap'},
                { name:"Görev Yeri",key:"DutyFirmLocation", thClass:"w-20",sortable:true,sortKey:"DutyFirmLocation.LocationName"},
            ],
            buttons:[
                { text:"Garaj ve Görev Yeri Düzenle",key:"plate",icon:"TargetIcon",variant:"primary",action:this.chooseGarageAndDuty },
                { text:"Treyler Ata",key:"assign",icon:"ArrowDownRightIcon",variant:"secondary",action:this.chooseTrailer,condition:(row)=>{ return row.IsTrailerAssignable && row.TrailerVehicleInventoryId == null } },
                { text:"Römork Ata",key:"assignR",icon:"ArrowDownRightIcon",variant:"secondary",action:this.chooseTrailer,condition:(row)=>{ return row.IsTruck && row.TrailerVehicleInventoryId == null } },
                { text:"Römork Atamasını Kaldır",key:"unassingR",icon:"XCircleIcon",variant:"secondary",action:this.unassignTrailer,condition:(row)=>{ return row.IsTruck && row.TrailerVehicleInventoryId != null } },
                { text:"Treyler Atamasını Kaldır",key:"unassing",icon:"XCircleIcon",variant:"danger",action:this.unassignTrailer,condition:(row)=>{ return row.IsTrailerAssignable && row.TrailerVehicleInventoryId != null } },
            ],
            tow:{
                MainVehicleInventoryId:null,
                Plate:null,
                TrailerVehicleInventoryId:null,
            },
            garageAndDuty:{
                MainVehicleInventoryId:null,
                VehicleInventoryGarageId:null,
                DutyFirmId:null,
                DutyFirm:null,
                DutyFirmLocationId:null,
                Plate:null,
            },
            isForTruck:false
        }
    },
    methods:{
        clearForm(){
            this.tow.MainVehicleInventoryId = null
            this.tow.Plate = null
            this.tow.TrailerVehicleInventoryId = null
            this.garageAndDuty.MainVehicleInventoryId = null
            this.garageAndDuty.VehicleInventoryGarageId = null
            this.garageAndDuty.DutyFirmId = null
            this.garageAndDuty.DutyFirm = null
            this.garageAndDuty.DutyFirmLocationId = null
            this.garageAndDuty.Plate = null
            this.isForTruck = false;
        },
        provider(data){
            return VehicleOperationsApi.Operational.Table(data)
        },
        chooseTrailer(item){
            this.clearForm()
            this.tow.MainVehicleInventoryId = item.MainVehicleInventoryId
            this.tow.Plate = item.MainVehicleInventoryPlate ? ['-',item.MainVehicleInventoryPlate].join(' ') : ''
            this.isForTruck = item.IsTruck
            this.$showModal("assign-to-tow")
        },
        chooseGarageAndDuty(item){
            this.clearForm()
            this.garageAndDuty.MainVehicleInventoryId = item.MainVehicleInventoryId
            this.garageAndDuty.Plate = item.MainVehicleInventoryPlate ? ['-',item.MainVehicleInventoryPlate].join(' ') : ''
            this.garageAndDuty.VehicleInventoryGarageId = item.GarageId
            this.garageAndDuty.DutyFirmId = item.DutyFirmId
            this.garageAndDuty.DutyFirm = item.DutyFirm
            this.garageAndDuty.DutyFirmLocationId = item.DutyFirmLocationId
            this.$showModal("assign-to-garage-and-duty")
        },
        assignTrailer(){
            this.loading = true
            VehicleOperationsApi.Operational.AssignTrailer(this.tow.MainVehicleInventoryId,this.tow.TrailerVehicleInventoryId)
            .then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal("assign-to-tow")
                    this.$refs.table.refresh()
                }
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        unassignTrailer(item){
            this.$confirm('Atamayı kaldırmak istediğinize emin misiniz?',`Bu işlem atamayı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    VehicleOperationsApi.Operational.UnassignTrailer(item.MainVehicleInventoryId).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        assignGarageAndDuty(){
            this.loading = true
            VehicleOperationsApi.Operational.AssignGarageAndDuty(this.garageAndDuty)
            .then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal("assign-to-garage-and-duty")
                    this.$refs.table.refresh()
                }
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
    }
}
</script>

<style>

</style>